import { mapStore, MapStore } from "../store";

export const updateMapSettings = <T extends keyof MapStore["settings"]>(key: T, value: MapStore["settings"][T]) => {
  mapStore.settings[key] = value;
};
